import * as THREE from "three";
import {
  useRef,
  useState,
  useEffect,
  useLocalStorage,
  useSessionStorage,
} from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Canvas, useFrame } from "@react-three/fiber";
import { CameraControls, Html, Stats, Sky, Stars } from "@react-three/drei";
import { isMobile } from "react-device-detect";
import { useThree } from "@react-three/fiber";
import PageVisibility from "react-page-visibility";
import useEventListener from "@use-it/event-listener";

import Header from "./Header";

//import { Perf } from 'r3f-perf'
//import data from './data.json'

import {
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";

/*
import buybutton from './imgs/buy.png';
import backbutton from './imgs/back.png'
import newbutton from './imgs/new.png';
import moreInfo from './imgs/moreInfo.png';
import lessInfo from './imgs/lessInfo.png';
import buy2 from './imgs/buy2.png';
import cancel from './imgs/cancel.png';
*/
//import { DateRange } from '@mui/icons-material'

/*
FIXED: Flickering far away
*/

import Pdf from './docs/legal.pdf';
import Pdf2 from './docs/privacy.pdf';

const requestEndpoint = process.env.REACT_APP_REQUEST_END_POINT;
const paymentGateway = process.env.REACT_APP_PAYMENTGATEWAYNEW;
const LockEndPoint = process.env.REACT_APP_LOCK_END_POINT;

var speed = 0.05;
var boxes = [];
var next = 10;

var fetchThat;

var randomPosX = (min = -10, max = 10) => Math.random() * (max - min) + min;
var randomPosY = (min = -10, max = 10) => Math.random() * (max - min) + min;
var randomPosZ = (min = -10, max = 10) => Math.random() * (max - min) + min;
var randomPosNew = (min = 0, max = 10) => Math.random() * (max - min) + min;

const getcss = (css, mobile) => {
  if (isMobile) {
    css = css + " " + mobile;
  }
  return css;
};

const openInNewTab = url => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

const TextMe3d = (props) => {
  function turnToPhrase(str) {
    var a = "";
    try {
      a = str.replace(/_/g, " ").replace(/\|/g, "\n").replace(/.{40}/g, '$&\n');
      //grab a string and put \n every N characters

    } catch (e) {
      a = str;
    }
    return a;
  }
  var divId = "clickme_" + props.Strawberry;

  return (
    <Html
      {...props}
      name={divId}
      transform
      position={[
        props.position[0] - 1,
        props.position[1],
        props.position[2] + 1,
      ]}
      style={{
        pointerEvents: "none",
        color: props.value === "-1" ? "#B200ED" : props.owner === props.userInfo ? "green" :  "blue",
        fontSize: "14px",
        width: "30vw",
        border: "0px solid red",
        fontFamily: "NewFont",
        whiteSpace: "break-spaces",
      }}
    >
      <div
        onClick={(e) => {
          props.handleClick(props.shape.current.position);
        }}
        style={{
          border: "0px solid green",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ margin: "auto" }}>
          {turnToPhrase(props.text)}
          <br />
          <br />
          {props.author != "" ? props.author : "Anonymous"}
        </div>
      </div>
    </Html>
  );
};

const CustomBox = (props) => {
  const navigate = useNavigate();

  const shape = useRef();
  const [hidden, setHidden] = useState(true);
  const [isMove, setIsMove] = useState(props.move);
  const [info, SetInfo] = useState(false);
  const [feedback, setFeedback] = useState("");

  useEffect(() => {
    setIsMove(props.move);
  }, [props.move]);

  const handleClick = (position) => {
    var pos = new THREE.Vector3();
    var look = new THREE.Vector3();

    if (isMove) {
      next = position.z;
      var sum = 2;
      pos.set(position.x, position.y, position.z + sum);
      look.set(position.x, position.y, position.z);
      props.cameraControlRef.current?.moveTo(pos.x, pos.y, pos.z, true);
      props.setTarget(pos);
      setHidden(false);
      props.setMove(false);
      props.setFooter(true);
      navigate("/" + props.Strawberry, { replace: true });
    }
    props.setHello(false);
  };

  function close() {
    //
    clearTimeout(fetchThat);
    props.setMove(true);
    props.setTarget();
    setHidden(true);
    props.setFooter(false);
    navigate("/");
  }

  async function buy(id) {
    navigate("/buy/" + id);
  }

  const openInSameTab = (url) => {
    window.open(url, "_self", "noopener,noreferrer");
  };

  function clickNew() {
    openInSameTab(process.env.PUBLIC_URL + "/new");
  }

  function clickNewId(Id) {
    openInSameTab(process.env.PUBLIC_URL + "/new/" + Id);
  }

  function logout() {
    props.setUserInfo();
    sessionStorage.removeItem("userinfo");
    sessionStorage.removeItem("wallet");
  }

  function clicMoreInfo() {
    var cv = document.getElementById("canvasDiv");
    var more = document.getElementById("MoreInfo");

    cv.hidden = true;
    more.hidden = false;

    //SetWant2buy(false);
    //navigate('/about');
  }

  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var created = new Date(Date.parse(props.createdAt));
  var createdString =
    months[created.getMonth()] +
    " " +
    created.getDate() +
    ", " +
    created.getFullYear();

  var value = (props.value / 100) * 2;


  var url = process.env.REACT_APP_PUBLIC_URL + "/" + props.finder_id;

  function stringtoshare(phrase){ 
    var end = "(...)\"";
    if (phrase.length < 100)
      end = "\"";
    var endPhrase = phrase.replace(/_/g, " ").replace(/\|/g, "\n").replace(/.{40}/g, '$&\n').substring(0, 100).split(" ").slice(0, -1).join(" ")

    return "\"" + endPhrase + end;

  }



  return (
    <group>
      <mesh
        ref={shape}
        position={[props.position[0] - 1, props.position[1], props.position[2]]}
        // onClick={(e) => { handleClick(e) }}
      >
        <boxGeometry args={[5, 5, 0.5]} />
        <meshBasicMaterial visible={false} color={"#90EE90"} wireframe />
      </mesh>

      {/* 
            <KeyboardObject  {...props} transparent={true}> </KeyboardObject>
           */}
      <Html
        position={[props.position[0] - 1, props.position[1], props.position[2]]}
        style={{
          transition: "all 0.05s",
          opacity: hidden ? 0 : 1,
          transform: `scale(${hidden ? 0 : 1})`,
        }}
        center
      >
        <div
          className={"mouse backToGalaxy text-xl"}
          onClick={(e) => close()}
          style={{ display: info ? "none" : "block" }}
        >
          {" "}
          [ BACK TO GALAXY ]{" "}
        </div>

        <div className="overlay"></div>

        <div className={getcss("ExplainInfoIdea", "ExplainInfoIdea_mobile")}>
          
          <div className="buttonsAction">
           
            

            {props.ForSale == 1 ? (
              props.owner === props.userInfo?.id ? (
                <div
                  className="text-xl mouse"
                  onClick={(e) => close()}
                >
                  [This is your idea]
                </div>
              ) : (
                <div
                  className="text-xl mouse"
                  onClick={(e) => buy(props.Strawberry)}
                >
                    [Buy This Idea]
                </div>
              )
            ) : (
              <div
                className="text-xl mouse"
                onClick={(e) => close()}
              >
                [Not for Sale, try another]
              </div>
            )}
             
          

            
            <div className="text-xl mouse" onClick={(e) => clickNew(e)}>
              [Mint new Idea] 
            </div>
            {props.value === "-1" ?
              <div className="text-xl mouse" onClick={(e) => clickNewId(props.Strawberry)}>
                [Mint this Idea]
              </div>
              :
              null
            }
            <div className="feedbackLayer">{feedback}</div>
          </div>
          <div className="buttonsShare">
            <div className="text-xl mouse" onClick={() => clicMoreInfo()}>
              [More info]
            </div>
            <br />
            Share
            <br />
            <TwitterShareButton
              url={url}
              title= {stringtoshare(props.idea) + " I Just found this idea in Hyperuranium!"}
              hashtags={["hyperuranium", "SharedIdeas"]} >
              <div className="text-xl mouseX">[X]</div>
            </TwitterShareButton>
            <LinkedinShareButton
              url={url}
              title={stringtoshare(props.idea) + " I Just found this idea in Hyperuranium!"}
            >
              <div className="text-xl mousefb">[Linkedin]</div>
            </LinkedinShareButton>
            <WhatsappShareButton
             url={url}
             title= {stringtoshare(props.idea) + " I Just found this idea in Hyperuranium!"}
            >
              <div className="text-xl mouseWs">[WhatsApp]</div>
            </WhatsappShareButton>
          </div>
          <div className="buttonsLogin">
            {props.userInfo?.token ? (
              <>
                <div
                  className="text-xl mouse"
                  onClick={(e) => openInSameTab("/profile")}
                >
                  [Profile]
                </div>
                <div className="text-xl mouse" onClick={(e) => logout()}>
                  [Logout]
                </div>
                <div
                  className="text-xl mouse"
                  onClick={(e) => openInSameTab("/listing")}
                >
                  [Listing]
                </div>
              </>
            ) : (
              <>
                <div className="mouse" onClick={(e) => openInSameTab("/login")}>
                  [Login]
                </div>
                <div
                  className="mouse"
                  onClick={(e) => openInSameTab("/register")}
                >
                  [Register]
                </div>
                <div
                  className="mouse"
                  onClick={(e) => openInSameTab("/listing")}
                >
                  [Listing]
                </div>
              </>
            )}
          </div>

          <form id="buyform" action={paymentGateway} method="POST">
            <input type="Hidden" name="price" value={value * 100} readOnly />
            <input
              type="Hidden"
              name="HWallet"
              value={
                window.localStorage.getItem("wallet") ===
                process.env.REACT_APP_OWNWALLET
                  ? true
                  : false
              }
              readOnly
            />
          </form>
        </div>
      </Html>
      <TextMe3d
        position={[props.position[0], props.position[1], props.position[2] - 2]}
        text={props.idea}
        value={props.value}
        author={props.author}
        Strawberry={props.Strawberry}
        shape={shape}
        handleClick={handleClick}
        owner={props.owner}
        userInfo={props.userInfo?.id}
      />
    </group>
  );
};
const FetchData = ({ setData, setHello, my, userInfo }) => {

  const { FilteredMessageid } = useParams();


  const getIdeas = async () => {
    try {
      //vasco

      
      var options = {};
        options = {
          headers: {
          'token': my && userInfo?.token ? userInfo.token : '',
          'target': FilteredMessageid || ''
          },
      }
      
      const response = await fetch(requestEndpoint, options);

      const data = await response.json();

      var newJson;

      newJson = data.map((obj) => {
        obj.x = randomPosX((-10 * data.length) / 20, (10 * data.length) / 20);
        obj.y = randomPosY((-10 * data.length) / 20, (10 * data.length) / 20);
        obj.z = randomPosZ(0, 30);
        obj.color = new THREE.Color("rgb(255,0,0)");
        return obj;
      });

      sessionStorage.setItem("data", JSON.stringify(newJson));
   
      setData(newJson);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    try {
      var d = JSON.parse(sessionStorage.getItem("data"));
      if (d == null) {
        getIdeas();
        setTimeout(() => {
          setHello(true);
        }, 7000);
      } else {
        getIdeas();
      }
    } catch (error) {
      
    }
  });
};

const BoxCreator = ({
  data,
  cameraControlRef,
  move,
  setMove,
  setTarget,
  finder_id,
  setFooter,
  setHello,
  setAbout,
  userInfo,
  setUserInfo,
}) => {
  const [lastZ, setLastZ] = useState(0);

  if (lastZ === 0) {
    
    for (let i = 0; i < data.length; i++) {
      data[i].z = data.length === 1 ? 10 : i * randomPosZ() * -0.5;
    }
    setLastZ(data[data.length - 1].z);
  }
  boxes = [];

  for (let i = 0; i < data.length; i++) {
    var name = "cube" + i;
    boxes.push({
      name: name,
      object: data[i],
      Thiskey: i,
    });
  }

  var newZ;

  useFrame((state) => {
    newZ = lastZ;

    var index = -1;

    for (var i = 0; i < data.length; i++) {
      if (data[i].z > state.camera.position.z) {
        newZ = lastZ - randomPosNew();
        setLastZ(newZ);
        index = i;
      }
    }

    if (index > -1) {
      data[index].z = newZ;
    }
  });

  return (
    <>
      {boxes.map((box, index) => (
        <CustomBox
          Strawberry={box.object.id}
          name={box.name}
          Thiskey={box.Thiskey}
          key={index}
          position={[box.object.x, box.object.y, box.object.z]}
          material-color={box.object.color}
          idea={box.object.phrase}
          author={box.object.author}
          wallet={box.object.wallet}
          username={box.object.username}
          owner={box.object.user.id}
          createdAt={box.object.createdAt}
          value={box.object.value}
          ForSale={box.object.ForSale}
          cameraControlRef={cameraControlRef}
          move={move}
          setMove={setMove}
          setTarget={setTarget}
          finder_id={finder_id}
          setFooter={setFooter}
          setHello={setHello}
          setAbout={setAbout}
          setUserInfo={setUserInfo}
          userInfo={userInfo}
        />
      ))}
    </>
  );
};

const BoxManager = (props) => {
  const {
    data,
    setData,
    cameraControlRef,
    move,
    setMove,
    setTarget,
    filter,
    finder_id,
    setFooter,
    setHello,
    setAbout,
    userInfo,
    setUserInfo,
    my,
  } = props;

  var filters = [
    (o) => o.phrase.toUpperCase().indexOf(filter.toUpperCase()) > -1,
  ];
  var data_filtered = data.filter((o) => filters.some((fn) => fn(o)));

  return (
    <>
      {data.length === 0 ? (
        <FetchData
          setData={setData}
          setHello={setHello}
          data={data}
          my={my}
          userInfo={userInfo}
        />
      ) : (
        <BoxCreator //todo testing
          data={data_filtered}
          cameraControlRef={cameraControlRef}
          move={move}
          setMove={setMove}
          setTarget={setTarget}
          finder_id={finder_id}
          setFooter={setFooter}
          setHello={setHello}
          setAbout={setAbout}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
        />
      )}
    </>
  );
};

const CameraGo = ({ cameraControlRef, move, target, setMove }) => {
  useEffect(() => {
    if (cameraControlRef.current) {
      cameraControlRef.current.maxPolarAngle = Math.PI / 2 + 0.17;
      cameraControlRef.current.minPolarAngle = Math.PI / 2 - 0.17;
      cameraControlRef.current.maxAzimuthAngle = 0 + 0.17;
      cameraControlRef.current.minAzimuthAngle = 0 - 0.17;

      cameraControlRef.current.noPan = true;
      cameraControlRef.current.maxDistance =
        cameraControlRef.current.minDistance =
          cameraControlRef.current.distance;
      cameraControlRef.current.noKeys = true;
      cameraControlRef.current.noRotate = true;
      cameraControlRef.current.noZoom = true;
    }
  }, [cameraControlRef]);

  useFrame((state, delta) => {
    if (move) {
      cameraControlRef.current?.moveTo(0, 0, next, true);
      next -= speed;
    } else {
      if (target) {
        cameraControlRef.current?.moveTo(
          target.x,
          target.y,
          target.z - 8,
          true
        );
      }
    }
  });

  return <CameraControls ref={cameraControlRef} />;
};

const openInSameTab = (url) => {
  window.open(url, "_self", "noopener,noreferrer");
};

function clickNew(whereTo) {
  openInSameTab(process.env.PUBLIC_URL + whereTo);
}

const Body = (props) => {
  const cameraControlRef = useRef([CameraControls]);
  const [data, setData] = useState([]);
  const [move, setMove] = useState(true);
  const [target, setTarget] = useState();
  const [filter, setFilter] = useState("");
  const [footer, setFooter] = useState(false);
  const [SStats, seStats] = useState(false);
  const [inclination, setInc] = useState(1.0);
  const [azimuth, setAzimuth] = useState(0);
  const [hello, setHello] = useState(false);
  const [about, setAbout] = useState(false);
  const [my, setMy] = useState(false);
  const hasPageBeenRendered = useRef(false);

  useEffect(() => {
    if (hasPageBeenRendered.current) {
      setData([]);
    }
    hasPageBeenRendered.current = true;
  }, [my]);

  var userdata = "";

  if (JSON.parse(sessionStorage.getItem("userinfo"))) {
    userdata = JSON.parse(sessionStorage.getItem("userinfo"));
  } else {
    userdata = "{id:0 , token:''}";
  }
  const [userInfo, setUserInfo] = useState({
    id: userdata.id ? userdata.id : 0,
    token: userdata.token ? userdata.token : "",
  });

  const { FilteredMessageid } = useParams();

  function FindPositionFromId({ id }) {
    const { scene } = useThree();
    if (id != null) {
      fetchThat = setTimeout(function () {
        var name = "clickme_" + id;
        var target = scene.getObjectByName(name);
        target.handleClick(target.position);
      }, 2000);
    }
  }

  const handlerD = (event) => {
    if (event.key === "ArrowDown") {
      if (inclination > 0) setInc(inclination - 0.01);
    }
    if (event.key === "ArrowUp") {
      if (inclination < 1) setInc(inclination + 0.01);
    }
    if (event.key === "ArrowLeft") {
      if (azimuth > 0) setAzimuth(azimuth - 0.1);
    }
    if (event.key === "ArrowRight") {
      if (azimuth < 1) setAzimuth(azimuth + 0.1);
    }
  };

  const handlerU = (event) => {
    if (event.key === "s") {
      seStats(!SStats);
    }
  };
  useEventListener("keydown", handlerD);
  useEventListener("keyup", handlerU);

  function Messages() {
    const [hide, setHide] = useState(false);

    if (hello && !FilteredMessageid) {
      setTimeout(() => {
        setHide(true);
        setTimeout(() => {
          setHello(false);
        }, 4500);
      }, 2000);
    }
    return (
      <div className={hide ? "fadeOut" : "full"}>
        <div> Please click on an Idea </div>
      </div>
    );
  }

  function closeMoreInfo() {
    var cv = document.getElementById("canvasDiv");
    var more = document.getElementById("MoreInfo");

    cv.hidden = false;
    more.hidden = true;
  }

  return (
    <div className={"MainW"}>
      {
        //<GalaxyFooter setFilter={setFilter} hide={!footer}/>
      }

      <Header bg={true} destination="/about" />
      {userInfo?.id ? (
        <span
          className={"top2 mouse2 linkOn2"}
          onMouseDown={() =>
            window.location.pathname === "/" ? setMy(!my) : null
          }
          onMouseEnter={() => {}}
          onMouseLeave={() => {}}
        >
          {my ? "MY" : "All"}
        </span>
      ) : null}

      {hello ? <Messages /> : null}
      <div className="MoreInfo" hidden id="MoreInfo">
        <div className="body_class">
          <div
            className="text-xl mouse2 moreinfo"
            onClick={() => closeMoreInfo()}
          >
            [ BACK ]
          </div>
          <div className="readMoreb">
           Ideas & Thoughts & Feelings & Visions <br />
            Questions & Beliefs & Clues & Schemes <br />
            Hypothesis & Purposes & Plans <br />
            Statements & Words & Messages & Prompts <br /> <br />
            They all live now and forever on Hyperuranium.
            <br />
            When tokenized, others start taking care of them.
            <br /> <br />
            this is the first autonomous version of our platform, which is
            forked from CENSORED.ART (https://censored.art).
            <br />
            <br />
            <div className="flex flex-row items-stretch w-full border-red-600 justify-evenly">
              <div className="flex flex-col items-start py-4 border-blue-500">
                <div
                  className="mouse2"
                  onClick={() => window.open("/new", "_self")}
                >
                  Mint Idea
                </div>
                <div
                  className="mouse2"
                  onClick={() => window.open("/listing", "_self")}
                >
                  Listing
                </div>
                <div
                  className="mouse2"
                  onClick={() => window.open("https://opensea.io/collection/hyperuranium", "_blank")}
                >
                  Contract on OpenSea
                </div>
                <div
                  className="mouse2"
                  onClick={() => window.open("https://polygonscan.com/address/0x94eABAE4f5085D630c112b2cEa8F1390423050E3", "_blank")}
                >
                  Contract on PolygonScan
                </div>
              
                <div className={'mouse2'} onClick={(e) => openInNewTab(Pdf)}>Terms & Conditions</div> 
                
                  <div className={'mouse2'} onClick={(e) => window.open("/contact", "_self")}>Notice & Take Down</div> 
                <br />
              </div>
              <div className="flex flex-col py-4 border-blue-500">
                {sessionStorage.getItem("userinfo") === null ? (
                  <div
                    className="mouse2"
                    onClick={() => window.open("/login", "_self")}
                  >
                    login
                  </div>
                ) : (
                  <div
                    className="mouse2"
                    onClick={() => {
                      sessionStorage.removeItem("userinfo");
                      window.location.reload();
                    }}
                  >
                    logout
                  </div>
                )}
                <div
                  className="mouse2"
                  onClick={() => window.open("/register", "_self")}
                >
                  Register
                </div>
                <div
                  className="mouse2"
                  onClick={() => window.open("/profile", "_self")}
                >
                  Profile
                </div>
                  
                <div className={'mouse2'} onClick={(e) => openInNewTab(Pdf2)}>Privacy</div> 
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="canvasDiv" id="canvasDiv">
        <Canvas
          width="520"
          height="520"
          linear
          camera={{ position: [0, 5, 15], fov: 60 }}
          frameloop="demand"
          gl={{ powerPreference: "high-performance", antialias: false }}
        >
          <FindPositionFromId id={FilteredMessageid} />

          <PageVisibility>
            {(isVisible) => (
              <CameraGo
                cameraControlRef={cameraControlRef}
                move={move}
                target={target}
                setMove={setMove}
              />
            )}
          </PageVisibility>

          <BoxManager
            data={data}
            setData={setData}
            filter={filter}
            cameraControlRef={cameraControlRef}
            move={move}
            setMove={setMove}
            setTarget={setTarget}
            finder_id={FilteredMessageid}
            setFooter={setFooter}
            setHello={setHello}
            setAbout={setAbout}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            my={my}
          />
          {SStats ? <Stats /> : null}
          {inclination > 0.25 && inclination < 0.75 ? (
            <Sky inclination={inclination} azimuth={azimuth} />
          ) : null}
          <Stars
            radius={100}
            depth={50}
            count={5000}
            factor={4}
            saturation={0}
            fade
            speed={1}
          />
          <Html></Html>
        </Canvas>
      </div>
    </div>
  );
};

export default Body;
